if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        //  Step 3: Load variant from URL params if present
        this.selectVariantFromParams();
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
        
      }

      resetProductFormState() {
        try {
          const productForm = this.productForm;
          if (productForm?.toggleSubmitButton) productForm.toggleSubmitButton(true);
          if (productForm?.handleErrorMessage) productForm.handleErrorMessage();
        } catch (e) {
          console.warn('resetProductFormState failed:', e);
        }
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          //this.updateURL(productUrl, variant?.id);
          this.updateURL(productUrl, variant);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            // document.querySelector(`#${targetId}`)?.focus();

            if (window.__initialVariantSelectionDone) {
              document.querySelector(`#${targetId}`)?.focus({ preventScroll: true });
            }
            window.__initialVariantSelectionDone = true;

          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              //console.log('Fetch aborted by user');
            } else {
              //console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          //this.updateURL(productUrl, variant?.id);
          this.updateURL(productUrl, variant);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
          if (variant && variant.option1) {
            filterGalleryByColor(variant.option1);
          }
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      // updateURL(url, variantId) {
      //   this.querySelector('share-button')?.updateUrl(
      //     `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
      //   );

      //   if (this.dataset.updateUrl === 'false') return;
      //   window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      // }
//start custom code
      // updateURL(url, variant) {
      //   this.querySelector('share-button')?.updateUrl(
      //     `${window.shopUrl}${url}${variant ? this.buildVariantParams(variant) : ''}`
      //   );

      //   if (this.dataset.updateUrl === 'false') return;
      //   window.history.replaceState({}, '', `${url}${variant ? this.buildVariantParams(variant) : ''}`);
      // }
      updateURL(url, variant) {
        const newParams = variant ? this.buildVariantParams(variant) : '';

        this.querySelector('share-button')?.updateUrl(`${window.shopUrl}${url}${newParams}`);

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${newParams}`);
      }
      buildVariantParams(variant) {
        if (!variant || !variant.options) return '';

        const params = new URLSearchParams();

        // Grab real option names from product JSON
        const productDataEl = document.querySelector('script[data-product]');
        const productData = productDataEl ? JSON.parse(productDataEl.textContent) : null;

        variant.options.forEach((value, i) => {
          const optionName = productData ? productData.options[i] : `option${i+1}`;
          params.set(optionName.toLowerCase(), value);
        });

        return `?${params.toString()}`;
      }
      // selectVariantFromParams() {
      //   const params = new URLSearchParams(window.location.search);
      //   if ([...params.keys()].length === 0) return;

      //   const productData = JSON.parse(this.querySelector('[data-product]').textContent);
      //   const matchedVariant = productData.variants.find(variant => {
      //     return productData.options.every((optionName, i) => {
      //       // const paramValue = params.get(optionName.toLowerCase());
      //       // return !paramValue || variant.options[i].toLowerCase() === paramValue.toLowerCase();
      //       const paramValueRaw = params.get(optionName.toLowerCase());
      //       const paramValue = paramValueRaw ? decodeURIComponent(paramValueRaw.replace(/\+/g, ' ')) : null;
      //       return !paramValue || variant.options[i].toLowerCase() === paramValue.toLowerCase();
      //     });
      //   });

      //   if (matchedVariant) {
      //     this.updateVariantInputs(matchedVariant.id);
      //     this.updateURL(this.dataset.url, matchedVariant);
      //   }
      // }
      selectVariantFromParams() {
      const params = new URLSearchParams(window.location.search);
      if ([...params.keys()].length === 0) return;

      const productData = JSON.parse(this.querySelector('[data-product]').textContent);

      // Decode parameters properly
      const decodedParams = {};
      for (const [key, val] of params.entries()) {
        decodedParams[key.toLowerCase()] = decodeURIComponent(val.replace(/\+/g, ' '));
      }

      const matchedVariant = productData.variants.find(variant => {
        const colorParam = decodedParams['color'];
        const sizeParam = decodedParams['size'];

        const colorMatch = !colorParam || variant.option1?.toLowerCase().trim() === colorParam.toLowerCase().trim();
        const sizeMatch  = !sizeParam  || variant.option2?.toLowerCase().trim() === sizeParam.toLowerCase().trim();

        return colorMatch && sizeMatch;
      });

    if (!matchedVariant) return;

    // 1) Update hidden variant inputs first
    this.updateVariantInputs(matchedVariant.id);

    // 2) Update visible controls (radios / selects) and dispatch change events
    const variantSelects = this.querySelector('variant-selects');

    if (variantSelects) {
      productData.options.forEach((optionName, i) => {
        const paramValue = decodedParams[optionName.toLowerCase()];
        if (!paramValue) return;

        try {
          // Try a few strategies to find the right fieldset for this option
          let fieldset = null;

          // Prefer fieldset whose legend starts with the option name
          const fsCandidates = Array.from(variantSelects.querySelectorAll('fieldset'));
          for (const fs of fsCandidates) {
            const legend = fs.querySelector('legend');
            if (legend && legend.textContent.trim().startsWith(optionName)) {
              fieldset = fs;
              break;
            }
          }

          // Fallback: class-based lookup (escaped)
          if (!fieldset) {
            try {
              fieldset = variantSelects.querySelector(`fieldset.${CSS.escape(optionName)}`);
            } catch (e) {
              // ignore CSS.escape errors on very old browsers
              fieldset = variantSelects.querySelector(`fieldset.${optionName}`);
            }
          }

          // If we found a fieldset, try to find radio input by case-insensitive match
          if (fieldset) {
            const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
            let matchedRadio = radios.find(r => r.value && r.value.toLowerCase() === paramValue.toLowerCase());

            if (!matchedRadio) {
              // fallback: try matching label text and click it
              const label = Array.from(fieldset.querySelectorAll('label')).find(l =>
                l.textContent.trim().toLowerCase().startsWith(paramValue.toLowerCase())
              );
              if (label) {
                label.click(); // this triggers the input change naturally
              }
            } else {
              // set radio + trigger change so VariantSelects.updateSelectionMetadata runs
              matchedRadio.checked = true;
              matchedRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          // Also handle the rare case of selects (dropdowns)
          const select = variantSelects.querySelector(`select[name="options[${optionName}]"]`);
          if (select) {
            select.value = paramValue;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } catch (e) {
          console.error('selectVariantFromParams: error selecting option', optionName, e);
        }
      });
    }

    // 3) Update URL and publish variant change (so price/media/etc. update)
    try {
      this.updateURL(this.dataset.url, matchedVariant);
      publish(PUB_SUB_EVENTS.variantChange, { data: { variant: matchedVariant } });
      if (matchedVariant && matchedVariant.option1) {
        filterGalleryByColor(matchedVariant.option1);
      }
    } catch (e) {
      console.error('selectVariantFromParams: error updating URL/publishing', e);
    }

    // 4) Auto-scroll featured image — run after a small delay and inside try/catch so it cannot break selection
    setTimeout(() => {
      try {
        const featuredMediaId = matchedVariant?.featured_media?.id;
        if (!featuredMediaId) return;

        const mediaGallery = this.querySelector('media-gallery');
        if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
          // use same id format Dawn expects
          mediaGallery.setActiveMedia(`${this.dataset.section}-${featuredMediaId}`, true);
          // scroll the item into view (try both prefixed and unprefixed data-media-id)
          const activeSlide =
            mediaGallery.querySelector(`[data-media-id="${this.dataset.section}-${featuredMediaId}"]`) ||
            mediaGallery.querySelector(`[data-media-id="${featuredMediaId}"]`);
          if (activeSlide) activeSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          // fallback: try gallery outside this element
          const galleryGlobal = document.querySelector('media-gallery');
          const thumb =
            galleryGlobal?.querySelector(`[data-media-id="${featuredMediaId}"], [data-media-id="${this.dataset.section}-${featuredMediaId}"]`);
          if (thumb && typeof thumb.click === 'function') thumb.click();
        }
      } catch (e) {
        console.error('selectVariantFromParams: error auto-scrolling media', e);
      }
    }, 150); // delay keeps this from racing with DOM updates; increase to 250-300ms if needed
  }

//end custom code
      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
